import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Desert,
  layer_id: EntityLayerId.TerrainL1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const DesertEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Desert),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type DesertEntity = InferOutput<typeof DesertEntitySchema>

/**
 * Arid, sandy terrain with sparse vegetation and minimal moisture.
 */
export const DesertEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Desert,
  dname: 'Desert',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 1,
  entDefaults,
}

export function createDesertEntity(id: number, x: number, y: number): DesertEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
